import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import parse from "html-react-parser";
import Divider from "@mui/material/Divider";
import cover from "./nofoto.jpg";
import { API_MEDIA, ApiUrlStatic } from "../../env";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

export default function RecipeReviewCard({
  name,
  date_birth,
  ves_kat,
  phone,
  email,
  image,
  aboutself,
  icon,
  bench,
  press,
  deadlift,
  sum,
  razrad,
}) {
  const Card_ = styled(Card)(({ theme }) => ({
    backgroundColor: theme.color.main,
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.color.secondary,
    width: "250px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  }));
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  console.log(`${API_MEDIA}${image}`);
  return (
    <Card_>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: grey[400] }} aria-label="recipe">
            {icon}
          </Avatar>
        }
        title={name}
        subheader={date_birth}
      />
      <CardMedia
        component="img"
        height="194"
        image={
          image && image != "null"
            ? `${API_MEDIA}${image}`
            : `${ApiUrlStatic}${cover}`
        }
        alt={name}
      />
      <CardContent>
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
          <b>Весовая категория-</b> {ves_kat}
        </Typography>
        <Divider />
        {(phone && phone != "null") || (email && email != "null") ? (
          <Typography
            variant="subtitle2"
            sx={{ color: "text.secondary" }}
            textAlign="center"
          >
            <b>Контакты</b>
          </Typography>
        ) : (
          <></>
        )}
        <Divider />
        {phone && phone != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Телефон-</b> {phone}
          </Typography>
        ) : (
          <></>
        )}
        {email && email != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Электронная почта-</b> {email}
          </Typography>
        ) : (
          <></>
        )}
        <Typography
          variant="subtitle2"
          sx={{ color: "text.secondary" }}
          textAlign="center"
        >
          <b>Достижения</b>
        </Typography>
        <Divider />
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
          <b>Разряд-</b> {razrad}
        </Typography>
        {bench && bench != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Присед-</b> {bench}
          </Typography>
        ) : (
          <></>
        )}
        {press && press != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Жим-</b> {press}
          </Typography>
        ) : (
          <></>
        )}
        {deadlift && deadlift != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Тяга-</b> {deadlift}
          </Typography>
        ) : (
          <></>
        )}
        {sum && sum != "null" ? (
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            <b>Сумма-</b> {sum}
          </Typography>
        ) : (
          <></>
        )}
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="нравится">
          <FavoriteIcon />
        </IconButton> */}
        {/* <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
        {aboutself && aboutself != "null" ? (
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        ) : (
          <></>
        )}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography variant="body2" sx={{ marginBottom: 2 }}>
            {parse(aboutself)}
          </Typography>
        </CardContent>
      </Collapse>
    </Card_>
  );
}
